

































































































































import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      button_active: false,
      button_width: 42,
      button_height: 26,
      button_line_width: 2,
      color: "2274a5",
      fix45: true,
      is_vanilla: false
    };
  },
  computed: {
    /**
     * ボタンの×印時の角度を算出します。
     */
    computed_rad(): number {
      if (this.fix45) {
        return Math.atan(1);
      }
      return Math.atan(this.button_height / this.button_width);
    },
    /**
     * ボタンの斜めの長さを算出します。
     */
    computed_bar_length(): number {
      if (this.fix45 && this.is_width_longer) {
        return (
          Math.round((this.button_height / Math.cos(this.computed_rad)) * 100) /
          100
        );
      }
      return (
        Math.round((this.button_width / Math.cos(this.computed_rad)) * 100) /
        100
      );
    },
    computed_left(): string {
      if (this.fix45 && this.is_width_longer) {
        return `${this.centering_horizontal}px;`;
      }
      return "0";
    },
    computed_top(): string {
      if (this.fix45 && !this.is_width_longer) {
        return `${this.centering_vertical}px;`;
      }
      return "0";
    },
    computed_bottom(): string {
      if (this.fix45 && !this.is_width_longer) {
        return `${this.centering_vertical}px;`;
      }
      return "0";
    },
    /**
     * 横の方が長いかを返します。
     */
    is_width_longer(): boolean {
      return this.button_height < this.button_width;
    },
    /**
     * ボタンタグのスタイル（全体の大きさ）を返します。
     */
    style_button(): string {
      return `
      width:${this.button_width}px;
      height:${this.button_height}px;
      `;
    },
    /**
     * 一番上のバーのスタイルを返します。
     */
    style_top(): string {
      return (
        this.style_width_height +
        this.css_left +
        this.css_top +
        this.css_transform_top +
        this.style_bg_color
      );
    },
    /**
     * 真ん中のバーのスタイルを返します。
     */
    style_middle(): string {
      return this.style_width_height + this.style_bg_color;
    },
    /**
     * 一番下のバーのスタイルを返します。
     */
    style_bottom(): string {
      return (
        this.style_width_height +
        this.css_left +
        this.css_bottom +
        this.css_transform_bottom +
        this.style_bg_color
      );
    },
    /**
     * バーの長さと高さを返します。
     */
    style_width_height(): string {
      if (this.button_active) {
        return `
        height:${this.button_line_width}px;
        width:${this.computed_bar_length}px;
        transform: translateY(-50%);
        `;
      }
      return `
      height:${this.button_line_width}px;
      width:${this.button_width}px;
      transform: translateY(-50%);
      `;
    },
    /**
     * 背景色を返します。
     */
    style_bg_color(): string {
      return `background-color: #${this.color}`;
    },
    /**
     * フォントの色を返します。
     */
    style_font_color(): string {
      return `color: #${this.color}`;
    },
    /**
     * 45度固定時に横方向の移動量を算出します。
     */
    centering_horizontal(): number {
      if (this.fix45 && this.is_width_longer) {
        return (this.button_width - this.button_height) / 2;
      }
      return 0;
    },
    /**
     * 45度固定時に縦方向の移動量を算出します。
     */
    centering_vertical(): number {
      if (this.fix45 && !this.is_width_longer) {
        return (this.button_height - this.button_width) / 2;
      }
      return 0;
    },
    /**
     * cssのleftの値を返します。
     */
    css_left(): string {
      if (this.button_active) {
        return `left: ${this.centering_horizontal}px;`;
      }
      return `left: 0;`;
    },
    /**
     * cssのtopの値を返します。
     */
    css_top(): string {
      if (this.button_active) {
        return `top: ${this.centering_vertical}px;`;
      }
      return `top: 0;`;
    },
    /**
     * cssのbottomの値を返します。
     */
    css_bottom(): string {
      if (this.button_active) {
        return `top: calc(100% - ${this.centering_vertical}px);`;
      }
      return `top: 100%;`;
    },
    /**
     * 一番上のバーのcssのtransformの値を返します。
     */
    css_transform_top(): string {
      if (this.button_active) {
        return `transform:rotate(${this.computed_rad}rad) translateY(-50%);`;
      }
      return `transform:rotate(0) translateY(-50%);`;
    },
    /**
     * 一番下のバーのcssのtransformの値を返します。
     */
    css_transform_bottom(): string {
      if (this.button_active) {
        return `transform:rotate(-${this.computed_rad}rad) translateY(-50%);`;
      }
      return `transform:rotate(0) translateY(-50%);`;
    }
  },
  mounted() {
    this.emit_to_parent();
  },
  methods: {
    /**
     * activeフラグを変更します。
     */
    activate(): void {
      this.button_active = !this.button_active;
    },
    /**
     * activeフラグを変更します。
     */
    check_fix45(): void {
      this.fix45 = !this.fix45;
      this.emit_to_parent();
    },
    /**
     * 出力をVanilla JSにします
     */
    check_is_vanilla() {
      this.is_vanilla = !this.is_vanilla;
      this.emit_to_parent();
    },
    /**
     * 親コンポーネントに値を渡します。
     */
    emit_to_parent() {
      this.$emit("css", {
        button_width: this.button_width,
        button_height: this.button_height,
        bar_line_width: this.button_line_width,
        active_line_length: this.computed_bar_length,
        left: this.centering_horizontal,
        top: this.centering_vertical,
        color: this.color,
        radian: this.computed_rad,
        is_vanilla: this.is_vanilla
      });
      // this.$emit("is_vanilla", { is_vanilla: this.is_vanilla });
    }
  }
});
